'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Given a particular key, return the
 * level title and class name
 * for a level.
 */

var parseLevel = function parseLevel(level) {
  return parseInt(level, 10);
};

var getTitleForLevel = function getTitleForLevel(level) {
  if (parseLevel(level) === 3) {
    return {
      title: 'Senior-Level',
      _class: 'senior-level'
    };
  } else if (parseLevel(level) === 2) {
    return {
      title: 'Mid-Level',
      _class: 'mid-level'
    };
  }

  return {
    title: 'Entry-Level',
    _class: 'entry-level'
  };
};

exports.default = getTitleForLevel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/getTitleForLevel.js
// module id = 186
// module chunks = 0